import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IExtraFieldConfigurationObject } from './ga-formly.service';

@Component({
  selector: 'formly',
  template: `
		<form [formGroup]="form" class="form-horizontal" [ngClass]="hostClasses" [noValidate]="noValidate">
			<formly-form [form]="form" [fields]="fields" [model]="model" class="row" [class.d-inline-flex]="inline" [ngClass]="classNames"></formly-form>
			<ng-content></ng-content>
		</form>
	`
})
export class GaFormlyComponent implements OnInit {
  @Input() public form:UntypedFormGroup;
  @Input() public fields:IExtraFieldConfigurationObject[];
  @Input() public model:any;
  @Input() public noValidate:boolean;
  @Input() public inline:boolean;
  @Input() public classNames:string;

  public hostClasses:string;

  constructor(private hostElement:ElementRef) {
  }

  public ngOnInit():void {
    // move classes from <formly> tag to <form> tag
    this.hostClasses = this.hostElement.nativeElement.className;
    this.hostElement.nativeElement.className = '';
  }
}